// components/Header.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css';
import MQTTService from './MQTTService'; // MQTT 서비스 가져오기
import {
  checkUserExists,
  checkPassword,
  saveToken,
  signupUser,
  logoutUser,
} from './DataHandler';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState<boolean>(false);
  const [signupOpen, setSignupOpen] = useState<boolean>(false);
  const [id, setId] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [isLoggedIn, setIsLoggedIn] = useState(false); // 로그인 상태 확인
  const [isConnected, setIsConnected] = useState(false); // MQTT 연결 상태
  const navigate = useNavigate();

  useEffect(() => {
    const mqttClient = MQTTService.getInstance().getClient();

    // MQTT 연결 상태 이벤트 핸들러 등록
    const handleConnect = () => setIsConnected(true);
    const handleDisconnect = () => setIsConnected(false);

    mqttClient.on('connect', handleConnect);
    mqttClient.on('close', handleDisconnect);

    // 클린업
    return () => {
      mqttClient.off('connect', handleConnect);
      mqttClient.off('close', handleDisconnect);
    };
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const handleLogin = async () => {
    try {
      const userCheck = await checkUserExists(id);

      if (!userCheck.exists) {
        alert('아이디가 존재하지 않습니다.');
        return;
      }

      const passwordCheck = await checkPassword(id, password);

      if (passwordCheck.valid) {
        await saveToken(id, passwordCheck.token);
        localStorage.setItem('token', passwordCheck.token);

        alert(`로그인 성공: ${id}`);
        setIsLoggedIn(true);
        setLoginOpen(false);
        navigate('/overview');
      } else {
        alert('비밀번호가 잘못되었습니다.');
      }
    } catch (error) {
      alert('서버 오류로 인해 로그인할 수 없습니다.');
    }
  };

  const handleSignup = async () => {
    try {
      const response = await signupUser(id);
      alert(response.message);
      setSignupOpen(false);
    } catch (error) {
      alert('서버 오류로 인해 회원가입을 할 수 없습니다.');
    }
  };

  const logout = async () => {
    try {
      const response = await logoutUser(id);
      alert(response.message);
      setIsLoggedIn(false);
      toggleMenu();
      navigate('/');
    } catch (error) {
      alert('서버 오류로 인해 로그아웃할 수 없습니다.');
    }
  };

  return (
    <header className="App-header">
      {/* 왼쪽 섹션: 햄버거 버튼과 로그인/회원가입 메뉴 */}
      <div className="left-section">
        <div className="menu-icon" onClick={toggleMenu}>
          <span></span><span></span><span></span>
        </div>
      </div>
        
        {/* 메뉴가 열렸을 때 로그인 및 회원가입 메뉴 표시 */}
        {menuOpen && (
          <div className="menu">
            {isLoggedIn ? (
              <div className="menu-container">
                <button onClick={() => { navigate('/settings'); toggleMenu(); }}>설정</button>
                <button onClick={() => { navigate('/overview'); toggleMenu(); }}>전체보기</button>
                <button onClick={logout}>로그아웃</button>
              </div>
            ) : (
                <div className="menu-container">
                  <button onClick={() => { setMenuOpen(false); setLoginOpen(true); }}>로그인</button>
                  <button onClick={() => { navigate('/ble'); toggleMenu(); }}>기기연결</button>
                  <button onClick={() => { setMenuOpen(false); setSignupOpen(true); }}>회원가입</button>
                  <button onClick={() => { setMenuOpen(false); setSignupOpen(true); }}>비밀번호잊음</button>
                  <button onClick={() => { setMenuOpen(false); setLoginOpen(false); setSignupOpen(false); }}>취소</button>
                </div>
            )}
          </div>
        )}
      

      {/* 중앙 제목 */}
      <h1 className="header-title">IoT PLC</h1>
      <h6>mqtt</h6><div className={`led-indicator ${isConnected ? 'led-on' : 'led-off'}`}></div>

      {/* 로그인 모달 */}
      {loginOpen && (
        <div className="menu">
          <div className="menu-container">
            <input
              type="text"
              placeholder="아이디"
              value={id}
              onChange={(e) => setId(e.target.value)}
            />
            <input
              type="password"
              placeholder="비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button onClick={handleLogin}>로그인</button>
            <button onClick={() => setLoginOpen(false)}>취소</button>
          </div>
        </div>
      )}

      {/* 회원가입 모달 */}
      {signupOpen && (
        <div className="menu">
          <div className="menu-container">
            <input
              type="text"
              placeholder="email 주소"
              value={id}
              onChange={(e) => setId(e.target.value)}
            />
            <button onClick={handleSignup}>임시 비밀번호를 메일로 보냄</button>
            <button onClick={() => setSignupOpen(false)}>취소</button>
          </div>
        </div>
      )}

    </header>
  );
}

export default Header;
